import { render, staticRenderFns } from "./DidRecords.vue?vue&type=template&id=2b25d3ce&"
import script from "./DidRecords.vue?vue&type=script&lang=js&"
export * from "./DidRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports